import React from "react";

interface SlidingLabelButtonProps {
  Icon: React.ReactNode;
  label: string;
  hoverColor?: string;
  active?: boolean;
  className?: string;
  href?: string;
}

const SlidingLabelButton = ({ Icon, label, hoverColor, active = false, className = "", href }: SlidingLabelButtonProps) => {
  return (
    <div className={`inline-flex items-center ${className}`}>
      <div className="group relative">
        <button className={`relative overflow-hidden rounded-md p-2 text-muted-foreground transition-all duration-200 group-hover:scale-105 group-hover:bg-zinc-200 ${active ? "scale-105 bg-primary text-primary-foreground" : "bg-muted"} ${!active ? "hover:text-accent-foreground" : ""} `}>
          <div className="relative">
            {Icon}
            {/* Sliding indicator */}
            <div className={`absolute -left-2 bottom-0 right-[20px] h-full w-[2px] -translate-x-2 transform rounded-full opacity-0 transition-all duration-200 ease-in-out group-hover:translate-x-0 group-hover:opacity-100 bg-${hoverColor ? "icons-" + hoverColor : "foreground"}`} />
          </div>
        </button>
        {/* Label moved outside the overflow:hidden container */}
        <span className="pointer-events-none absolute left-[46px] top-1/2 z-50 -translate-y-1/2 translate-x-[-1rem] transform whitespace-nowrap rounded-md bg-primary px-2 py-1 text-xs text-primary-foreground opacity-0 transition-all duration-300 ease-in-out group-hover:translate-x-0 group-hover:opacity-100">
          {label}
        </span>
      </div>
    </div>
  );
};

export default SlidingLabelButton;
